const en = {
  // Navigation
  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.services': 'Services',
  'nav.revenueSharing': 'Revenue Sharing',
  'nav.partnership': 'Partnership',
  'nav.joinUs': 'Join Us',
  'nav.contact': 'Contact',
  'nav.getStarted': 'Get Started',
  'nav.switchLang': 'عربي',

  // WhatsApp
  'wa.tooltip': 'Chat with us on WhatsApp',

  // Footer
  'footer.brandDesc': 'Building the future, one line of code at a time. Professional tech solutions for businesses that refuse to settle.',
  'footer.servicesTitle': 'Services',
  'footer.companyTitle': 'Company',
  'footer.contactTitle': 'Contact',
  'footer.emailLabel': 'Email Us',
  'footer.phoneLabel': 'Call Us',
  'footer.availLabel': 'Availability',
  'footer.availValue': 'Global Services',
  'footer.copyright': '© {{year}} Unique Code. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.srv1': 'Branding & Design',
  'footer.srv2': 'Web Development',
  'footer.srv3': 'Mobile Applications',
  'footer.srv4': 'AI & Smart Tech',
  'footer.srv5': 'Digital Marketing',
  'footer.srv6': 'IT Consulting',
  'footer.lnk1': 'About Us',
  'footer.lnk2': 'Our Team',
  'footer.lnk3': 'Join Us',
  'footer.lnk4': 'Revenue Sharing',
  'footer.lnk5': 'Contact Us',
  'footer.lnk6': 'Partnership',

  // Hero
  'hero.badge': 'Trusted by 500+ Clients Worldwide',
  'hero.title1': 'Transform Your',
  'hero.title2': 'Digital Vision',
  'hero.title3': 'Into Reality',
  'hero.desc': 'We craft cutting-edge technology solutions, from web and mobile apps to AI-powered systems, that drive measurable growth for your business.',
  'hero.cta1': 'Start Your Project',
  'hero.cta2': 'Explore Services',
  'hero.statClients': 'Clients',
  'hero.statProjects': 'Projects',
  'hero.statCountries': 'Countries',
  'hero.statYears': 'Years',

  // Stats
  'stats.label': 'Our Numbers Speak',
  'stats.title': 'Proven Track Record',
  'stats.clientsLabel': 'Happy Clients',
  'stats.clientsDesc': 'Across the globe',
  'stats.projectsLabel': 'Projects Delivered',
  'stats.projectsDesc': 'On time & on budget',
  'stats.yearsLabel': 'Years of Excellence',
  'stats.yearsDesc': 'Industry experience',
  'stats.countriesLabel': 'Countries Served',
  'stats.countriesDesc': 'Global presence',

  // Why Choose Us
  'whyUs.label': 'Why Work With Us',
  'whyUs.title': 'What Sets Us Apart?',
  'whyUs.desc': 'We combine technical excellence with strategic thinking to deliver solutions that truly move the needle for your business.',
  'whyUs.item1Title': 'Innovation First',
  'whyUs.item1Desc': 'We push boundaries with cutting-edge technologies. Our team constantly explores new tools and frameworks to deliver future-ready solutions.',
  'whyUs.item2Title': 'Peak Performance',
  'whyUs.item2Desc': "Every product we build is optimized for speed, scalability, and reliability. Performance is not an afterthought; it's baked in from day one.",
  'whyUs.item3Title': 'Client-Centered',
  'whyUs.item3Desc': 'Your success is our mission. We maintain transparent communication, deliver on time, and provide ongoing support after every project launch.',
  'whyUs.item4Title': 'Global Expertise',
  'whyUs.item4Desc': 'With projects across 50+ countries, we understand diverse markets and bring international best practices to every engagement.',
  'whyUs.item5Title': 'Secure & Reliable',
  'whyUs.item5Desc': "We apply enterprise-grade security standards in every product we build, ensuring your data and your customers' data is always protected.",
  'whyUs.item6Title': 'Agile & Flexible',
  'whyUs.item6Desc': "We adapt to your workflow. Whether it's a startup MVP or enterprise software, we scale our process to your needs and timeline.",

  // Why Choose Unique Code
  'whyUC.label': 'Our Advantage',
  'whyUC.title1': 'Why Choose',
  'whyUC.title2': 'Unique Code?',
  'whyUC.desc': "We're not just a software company. We're your long-term technology partner. From concept to launch and beyond, we stay with you every step of the way.",
  'whyUC.f1Title': 'Secure & Reliable',
  'whyUC.f1Desc': 'Enterprise-grade security standards across every product we ship.',
  'whyUC.f2Title': '24/7 Dedicated Support',
  'whyUC.f2Desc': 'Our team is always available to help, day or night.',
  'whyUC.f3Title': 'On-Time Delivery',
  'whyUC.f3Desc': 'We respect deadlines. Every milestone met, every time.',
  'whyUC.f4Title': 'Global Reach',
  'whyUC.f4Desc': 'Serving clients across 50+ countries with local expertise.',
  'whyUC.f5Title': 'Expert Team',
  'whyUC.f5Desc': '30+ specialists in design, engineering, AI, and marketing.',
  'whyUC.f6Title': 'Award-Winning Work',
  'whyUC.f6Desc': 'Recognized for excellence in digital product design.',
  'whyUC.satisfactionLabel': 'Client Satisfaction',
  'whyUC.ratingLabel': 'Average Rating',

  // Core Services (Home)
  'svc.label': 'What We Do',
  'svc.title': 'Our Core Services',
  'svc.viewAll': 'View All Services',
  'svc.learnMore': 'Learn More',
  'svc.item1Title': 'Branding & Design',
  'svc.item1Desc': 'We craft powerful visual identities that make your brand unforgettable. From logos to full brand systems, we define who you are visually.',
  'svc.item1Tag': 'Creative',
  'svc.item2Title': 'Web Development',
  'svc.item2Desc': 'We build fast, responsive, and conversion-optimized websites using the latest technologies. Your digital presence, engineered for results.',
  'svc.item2Tag': 'Engineering',
  'svc.item3Title': 'Mobile Applications',
  'svc.item3Desc': 'Native iOS and Android apps that users love. We design and develop high-performance mobile solutions that drive engagement and retention.',
  'svc.item3Tag': 'Mobile',
  'svc.item4Title': 'AI & Smart Technology',
  'svc.item4Desc': 'Harness the power of AI, machine learning, and IoT to automate processes and gain competitive intelligence at scale.',
  'svc.item4Tag': 'AI / ML',
  'svc.item5Title': 'Digital Marketing',
  'svc.item5Desc': 'Data-driven marketing strategies that generate leads, grow your audience, and maximize ROI. We also offer unique revenue-sharing models.',
  'svc.item5Tag': 'Growth',
  'svc.item6Title': 'IT Consulting',
  'svc.item6Desc': 'Strategic technology consulting to align your IT infrastructure with your business goals. We audit, plan, and implement with precision.',
  'svc.item6Tag': 'Consulting',

  // Testimonials
  'tst.label': 'Client Stories',
  'tst.title': 'What Our Clients Say',
  'tst.desc': "Don't just take our word for it. Hear directly from the businesses we've helped grow.",
  'tst.item1Name': 'Ahmed Al-Rashid',
  'tst.item1Role': 'CEO, TechBridge Arabia',
  'tst.item1Text': 'Unique Code delivered our e-commerce platform ahead of schedule and it exceeded every expectation. The attention to detail and quality of code is remarkable.',
  'tst.item2Name': 'Sarah Mitchell',
  'tst.item2Role': 'Product Director, NovaSoft',
  'tst.item2Text': 'The mobile app they built for us has a 4.9-star rating on the App Store. Their UI/UX team truly understands user behavior and translates it into beautiful, functional design.',
  'tst.item3Name': 'Khalid Al-Mansouri',
  'tst.item3Role': 'Founder, FinTech Gulf',
  'tst.item3Text': 'Our AI-powered risk analysis system, built by Unique Code, has reduced manual processing time by 80%. Absolutely transformative for our operations.',

  // CTA
  'cta.badge': 'Ready to Launch?',
  'cta.title1': "Let's Build Something",
  'cta.title2': 'Extraordinary',
  'cta.desc': "Whether you're a startup with a bold idea or an enterprise looking to innovate, we have the expertise to turn your vision into a world-class digital product.",
  'cta.btn1': 'Get In Touch',
  'cta.btn2': 'Join Our Team',
  'cta.trust1': 'Enterprise Security',
  'cta.trust2': 'On-Time Delivery',
  'cta.trust3': '24/7 Support',
  'cta.trust4': 'Award-Winning',

  // About Page
  'about.heroLabel': 'Who We Are',
  'about.heroTitle1': 'The Team Behind',
  'about.heroTitle2': 'Your Digital Success',
  'about.heroDesc': 'Unique Code is a global technology company building digital experiences that transform businesses. From startups to enterprises, we make technology work for you.',
  'about.purposeLabel': 'Our Purpose',
  'about.purposeTitle': 'Mission & Vision',
  'about.missionTitle': 'Our Mission',
  'about.missionDesc': 'To empower businesses worldwide with cutting-edge technology solutions that drive measurable growth, operational efficiency, and lasting competitive advantage.',
  'about.visionTitle': 'Our Vision',
  'about.visionDesc': 'To be the most trusted technology partner for businesses across the globe, renowned for innovation, quality, and transformative impact in every project we undertake.',
  'about.promiseTitle': 'Our Promise',
  'about.promiseDesc': "Every project we touch receives our full commitment, from strategy to launch and beyond. We're not just vendors, we're your long-term technology partners.",
  'about.yearsCard': '9+',
  'about.yearsLabel': 'Years of Excellence',
  'about.satisfactionCard': '98%',
  'about.satisfactionLabel': 'Client Satisfaction',
  'about.valuesLabel': 'What Drives Us',
  'about.valuesTitle': 'Our Core Values',
  'about.val1Title': 'Innovation First',
  'about.val1Desc': 'We constantly push the boundaries of technology to deliver forward-thinking solutions.',
  'about.val2Title': 'Integrity Always',
  'about.val2Desc': 'Honesty and transparency are the foundation of every client relationship we build.',
  'about.val3Title': 'Excellence Driven',
  'about.val3Desc': 'We settle for nothing less than exceptional results in everything we do.',
  'about.val4Title': 'Client-Centric',
  'about.val4Desc': 'Your success is our metric. We design solutions around your unique challenges.',
  'about.val5Title': 'Global Thinking',
  'about.val5Desc': 'With clients in 50+ countries, we bring a global perspective to every project.',
  'about.val6Title': 'Sustainable Growth',
  'about.val6Desc': 'We build solutions that scale with your business for years to come.',
  'about.timelineLabel': 'Our Story',
  'about.timelineTitle': 'The Unique Code Journey',
  'about.ms1Year': '2017',
  'about.ms1Title': 'Founded',
  'about.ms1Desc': 'Unique Code was established in 2017 with a mission to democratize premium tech for all businesses.',
  'about.ms2Year': '2020',
  'about.ms2Title': '100 Clients',
  'about.ms2Desc': 'Reached our first 100 clients milestone despite global challenges, proving the demand for quality tech.',
  'about.ms3Year': '2021',
  'about.ms3Title': 'Global Expansion',
  'about.ms3Desc': 'Expanded operations to serve clients across the Middle East, Europe, and North America.',
  'about.ms4Year': '2022',
  'about.ms4Title': 'AI Division Launch',
  'about.ms4Desc': 'Launched our dedicated AI & Smart Technology division to lead the next wave of innovation.',
  'about.ms5Year': '2023',
  'about.ms5Title': '500+ Projects',
  'about.ms5Desc': 'Delivered over 500 successful projects and grew to a team of 80+ specialists.',
  'about.ms6Year': '2024',
  'about.ms6Title': '50+ Countries',
  'about.ms6Desc': 'Now serving clients across 50+ countries with our revenue-sharing model disrupting the industry.',
  'about.teamLabel': 'The Experts',
  'about.teamTitle': 'Meet Our Leadership',
  'about.teamDesc': 'Visionaries, creators, and engineers united by a passion for building extraordinary digital experiences.',
  'about.t1Name': 'Ahmed Al-Rashid',
  'about.t1Role': 'CEO & Founder',
  'about.t1Bio': 'Visionary leader with 12+ years in tech. Built Unique Code to redefine digital transformation for businesses worldwide.',
  'about.t2Name': 'Sara Al-Mansouri',
  'about.t2Role': 'Chief Design Officer',
  'about.t2Bio': 'Award-winning designer who has shaped brand identities for over 200 companies across 30+ countries.',
  'about.t3Name': 'Omar Khalid',
  'about.t3Role': 'CTO',
  'about.t3Bio': 'Full-stack architect and AI enthusiast with a track record of delivering scalable enterprise platforms.',
  'about.t4Name': 'Fatima Hassan',
  'about.t4Role': 'Head of AI & Innovation',
  'about.t4Bio': 'Machine learning expert who brings cutting-edge AI solutions to business challenges with practical impact.',
  'about.ctaTitle': 'Ready to Build Something Amazing?',
  'about.ctaDesc': 'Join 500+ businesses that trust Unique Code to drive their digital growth.',
  'about.ctaBtn1': 'Get In Touch',
  'about.ctaBtn2': 'Join Our Team',

  // Services Page
  'srvPage.heroLabel': 'What We Offer',
  'srvPage.heroTitle1': 'End-to-End',
  'srvPage.heroTitle2': 'Tech Services',
  'srvPage.heroDesc': 'From brand identity to AI, we cover every dimension of your digital needs with precision, creativity, and measurable outcomes.',
  'srvPage.selectLabel': 'Select Service',
  'srvPage.getQuote': 'Get a Quote',
  'srvPage.whatsIncluded': "What's Included",
  'srvPage.overviewLabel': 'Everything We Do',
  'srvPage.overviewTitle': 'Our Full Service Suite',
  'srvPage.processLabel': 'How We Work',
  'srvPage.processTitle': 'Our Proven Process',
  'srvPage.ctaTitle': "Let's Start Building",
  'srvPage.ctaDesc': 'Tell us your idea and we will turn it into something remarkable. No commitment needed for the first consultation.',
  'srvPage.ctaBtn': 'Request a Free Consultation',
  'srvPage.process1Title': 'Discovery',
  'srvPage.process1Desc': 'We start by deeply understanding your business, goals, and challenges through structured discovery sessions.',
  'srvPage.process2Title': 'Strategy',
  'srvPage.process2Desc': 'Our team creates a tailored roadmap with clear milestones, technologies, and expected outcomes.',
  'srvPage.process3Title': 'Build',
  'srvPage.process3Desc': 'We execute with precision: iterative sprints, regular demos, and full transparency throughout development.',
  'srvPage.process4Title': 'Launch & Scale',
  'srvPage.process4Desc': 'We deploy, monitor, optimize, and support your product long after launch for continued growth.',

  // Contact Page
  'contact.heroLabel': 'Get In Touch',
  'contact.heroTitle1': "Let's Start a",
  'contact.heroTitle2': 'Conversation',
  'contact.heroDesc': "Have a project in mind? A question about our services? Or just want to explore what we can do together? Reach out. We respond within 24 hours.",
  'contact.infoLabel': 'Contact Details',
  'contact.infoTitle': "We'd Love to Hear From You",
  'contact.infoDesc': "Whether you're a startup with a big idea, an enterprise looking to modernize, or an individual exploring partnership opportunities, our team is here to help.",
  'contact.followTitle': 'Follow Us',
  'contact.formTitle': 'Send Us a Message',
  'contact.nameLabel': 'Full Name',
  'contact.namePlaceholder': 'Your name',
  'contact.emailLabel2': 'Email Address',
  'contact.emailPlaceholder': 'your@email.com',
  'contact.phoneLabel2': 'Phone Number',
  'contact.phonePlaceholder': '+966 5XX XXX XXXX',
  'contact.companyLabel': 'Company Name',
  'contact.companyPlaceholder': 'Your company (optional)',
  'contact.serviceLabel': "Service You're Interested In",
  'contact.serviceDefault': 'Select a service',
  'contact.budgetLabel': 'Project Budget',
  'contact.budgetDefault': 'Select a budget range',
  'contact.messageLabel': 'Tell Us About Your Project',
  'contact.messagePlaceholder': 'Describe your project, goals, and any timeline requirements...',
  'contact.submitBtn': 'Send Message',
  'contact.sendingText': 'Sending...',
  'contact.successTitle': 'Message Sent!',
  'contact.successDesc': 'Thanks for reaching out! A member of our team will get back to you within 24 hours.',
  'contact.successBtn': 'Send Another Message',
  'contact.errorText': 'Something went wrong. Please try again.',
  'contact.locationValue': 'Riyadh, Saudi Arabia',
  'contact.hoursValue': 'Sun–Thu: 9AM – 6PM',

  // Join Page
  'join.heroLabel': 'Careers',
  'join.heroTitle1': 'Build the Future',
  'join.heroTitle2': 'With Us',
  'join.heroDesc': 'Join a team of passionate builders, designers, and innovators creating digital products that impact millions of people worldwide.',
  'join.heroBadge': "We're Hiring: {{count}} Open Positions",
  'join.perksLabel': 'Why Join Us',
  'join.perksTitle': 'Life at Unique Code',
  'join.openingsLabel': 'Open Roles',
  'join.openingsTitle': 'Current Openings',
  'join.applyLabel': 'Apply Now',
  'join.applyTitle': 'Send Your Application',
  'join.applySelected': 'Applying for: {{role}}',
  'join.applyDefault': 'Select a role above or apply for a general position',
  'join.nameLabel': 'Full Name',
  'join.emailLabel': 'Email Address',
  'join.phoneLabel': 'Phone Number',
  'join.expLabel': 'Years of Experience',
  'join.roleLabel': 'Position Applying For',
  'join.portfolioLabel': 'Portfolio / LinkedIn URL',
  'join.cvLabel': 'CV / Resume Link',
  'join.cvPlaceholder': 'Google Drive, Dropbox or any public link...',
  'join.cvNote': 'Share a link to your CV (Google Drive, Dropbox, OneDrive, etc.)',
  'join.aboutLabel': 'Tell Us About Yourself',
  'join.submitBtn': 'Submit Application',
  'join.submittingText': 'Submitting...',
  'join.successTitle': 'Application Received!',
  'join.successDesc': 'We review applications personally. Expect to hear from us within 3–5 business days.',
  'join.successBtn': 'Submit Another',
  'join.errorText': 'Something went wrong. Please try again.',
  'join.selectPosition': 'Select a position',
  'join.generalApp': 'General Application',
  'join.fulltime': 'Full-time',
  'join.hybrid': 'Hybrid',
  'join.remote': 'Remote',
  // Job openings
  'join.o1role': 'Senior Frontend Developer',
  'join.o1team': 'Engineering',
  'join.o1desc': 'Build exceptional web experiences with React, TypeScript, and modern frontend tooling.',
  'join.o2role': 'UI/UX Designer',
  'join.o2team': 'Design',
  'join.o2desc': 'Craft user-centered interfaces for web and mobile products across diverse client projects.',
  'join.o3role': 'Mobile App Developer',
  'join.o3team': 'Engineering',
  'join.o3desc': 'Develop high-quality iOS and Android apps using React Native and native technologies.',
  'join.o4role': 'AI/ML Engineer',
  'join.o4team': 'AI Division',
  'join.o4desc': 'Build intelligent systems and machine learning models that solve real business problems.',
  'join.o5role': 'Digital Marketing Specialist',
  'join.o5team': 'Marketing',
  'join.o5desc': 'Run data-driven campaigns across paid, organic, and social channels for 30+ active clients.',
  'join.o6role': 'Sales Executive',
  'join.o6team': 'Business Development',
  'join.o6desc': 'Drive new business across GCC and international markets with our premium tech portfolio.',
  // Perks
  'join.p1title': 'Remote-First',
  'join.p1desc': 'Work from anywhere in the world. We trust you to deliver.',
  'join.p2title': 'Competitive Pay',
  'join.p2desc': 'Market-leading salaries plus performance bonuses.',
  'join.p3title': 'Learning Budget',
  'join.p3desc': 'Annual budget for courses, certifications, and conferences.',
  'join.p4title': 'Health Coverage',
  'join.p4desc': 'Full medical and wellness coverage for you and your family.',
  'join.p5title': 'Flexible Hours',
  'join.p5desc': 'Results-oriented culture. Own your schedule.',
  'join.p6title': 'Growth Path',
  'join.p6desc': 'Clear career ladders with leadership opportunities at every level.',

  // Revenue Sharing
  'rev.heroLabel': 'Partnership Model',
  'rev.heroTitle1': 'We Grow',
  'rev.heroTitle2': 'Together',
  'rev.heroBadge': 'Our Unique Partnership Model',
  'rev.heroSubtitle': 'You Only Pay When You Profit.',
  'rev.heroDesc': "Unique Code's revenue-sharing model means we invest in your marketing alongside you. If you don't grow, we don't earn. It's the most aligned partnership in the industry.",
  'rev.exploreBtn': 'Explore Partnership',
  'rev.modelLabel': 'The Model Explained',
  'rev.modelTitle': 'What Is Revenue Sharing?',
  'rev.modelDesc1': 'Revenue sharing is a performance-based partnership model where Unique Code invests its expertise, team, and resources into growing your business, and in return, receives a pre-agreed percentage of the new revenue we generate for you.',
  'rev.modelDesc2': "Unlike traditional agencies that charge large monthly retainers regardless of results, our model means every member of our team is personally motivated to deliver exceptional outcomes. Your win is our win.",
  'rev.stat1Label': 'Clients on this model',
  'rev.stat1Value': '120+',
  'rev.stat2Label': 'Avg. revenue growth',
  'rev.stat2Value': '3.8x',
  'rev.stat3Label': 'Industries served',
  'rev.stat3Value': '15+',
  'rev.stat4Label': 'Satisfaction rate',
  'rev.stat4Value': '97%',
  'rev.processLabel': 'The Process',
  'rev.processTitle': 'How It Works',
  'rev.step1Title': 'Initial Consultation',
  'rev.step1Desc': 'We meet to understand your business model, growth goals, and marketing needs.',
  'rev.step2Title': 'Custom Agreement',
  'rev.step2Desc': "We craft a transparent revenue-sharing agreement tailored to your business and risk tolerance.",
  'rev.step3Title': 'We Execute & Invest',
  'rev.step3Desc': 'Our team launches full marketing campaigns. We absorb the upfront cost, you watch leads come in.',
  'rev.step4Title': 'Revenue Split',
  'rev.step4Desc': "As revenue grows, we receive our agreed percentage. No results, no full payment. It's that simple.",
  'rev.benefitsLabel': 'Why This Works',
  'rev.benefitsTitle': 'The Benefits of Partnering With Us',
  'rev.ben1Title': 'Zero Upfront Risk',
  'rev.ben1Desc': "You don't pay large retainers. We invest in your growth and earn when you earn.",
  'rev.ben2Title': 'Aligned Incentives',
  'rev.ben2Desc': 'Our team is 100% motivated to deliver results because we share in your success.',
  'rev.ben3Title': 'Proven Expertise',
  'rev.ben3Desc': "We've run this model across 50+ businesses in 15+ industries with consistent results.",
  'rev.ben4Title': 'Flexible Models',
  'rev.ben4Desc': 'We adapt the revenue share percentage and terms to your specific business stage and goals.',
  'rev.ben5Title': 'Full Service Team',
  'rev.ben5Desc': 'You get a dedicated team of marketers, designers, and analysts working on your growth.',
  'rev.ben6Title': 'Scalable Growth',
  'rev.ben6Desc': 'As your business scales, our capacity scales with you. No vendor lock-in, just growth.',
  'rev.faqLabel': 'Common Questions',
  'rev.faqTitle': 'Frequently Asked Questions',
  'rev.faq1Q': 'What percentage of revenue does Unique Code take?',
  'rev.faq1A': 'It varies by industry and campaign scale, but typically ranges between 15%–30% of new revenue generated from our efforts. This is negotiated transparently upfront.',
  'rev.faq2Q': 'Is there any upfront cost at all?',
  'rev.faq2A': "We require a minimal onboarding fee to cover setup and strategy, far below typical agency retainers. After that, it's purely performance-based.",
  'rev.faq3Q': 'How long is the minimum contract?',
  'rev.faq3A': 'We recommend a minimum 6-month commitment to see meaningful results. Most clients stay long-term once they see the compounding growth.',
  'rev.faq4Q': 'Which industries does this work for?',
  'rev.faq4A': "We've successfully run this model in e-commerce, real estate, SaaS, healthcare, education, hospitality, and more. Book a call to assess your industry fit.",
  'rev.faq5Q': 'How is revenue tracked and verified?',
  'rev.faq5A': 'We integrate directly with your CRM, analytics tools, and payment systems to ensure transparent, auditable tracking of every lead and conversion we generate.',
  'rev.faq6Q': 'Can I switch to a standard retainer later?',
  'rev.faq6A': 'Absolutely. Many clients start with revenue sharing and transition to a hybrid or retainer model once trust is established and budgets grow.',
  'rev.ctaTitle': 'Ready to Grow Together?',
  'rev.ctaDesc': "Book a free strategy call and let's explore if our revenue-sharing model is the right fit for your business.",
  'rev.ctaBtn': 'Apply for Partnership',

  // Services Page - Long Descriptions & Features
  'srvPage.branding.longDesc': 'Your brand is the first impression you make, and we make sure it lasts. Our design team works with you to build cohesive, meaningful identities that stand out in crowded markets.',
  'srvPage.branding.f1': 'Logo Design & Brand Identity',
  'srvPage.branding.f2': 'UI/UX Design for Web & Mobile',
  'srvPage.branding.f3': 'Brand Guidelines & Style Guides',
  'srvPage.branding.f4': 'Marketing Materials & Print',
  'srvPage.branding.f5': 'Motion Graphics & Animation',
  'srvPage.branding.f6': 'Social Media Visual Kits',

  'srvPage.web.longDesc': 'We build web experiences that combine stunning design with rock-solid engineering. Whether you need a marketing site, a complex SaaS platform, or an e-commerce engine — we deliver.',
  'srvPage.web.f1': 'Custom Website Development',
  'srvPage.web.f2': 'E-Commerce & Online Stores',
  'srvPage.web.f3': 'SaaS & Web Applications',
  'srvPage.web.f4': 'CMS Integration',
  'srvPage.web.f5': 'Performance Optimization & SEO',
  'srvPage.web.f6': 'API Development & Integration',

  'srvPage.mobile.longDesc': 'Mobile is where your customers live. We design and develop high-performance mobile applications that deliver real business value — from consumer apps to enterprise tools.',
  'srvPage.mobile.f1': 'iOS (Swift) Development',
  'srvPage.mobile.f2': 'Android (Kotlin) Development',
  'srvPage.mobile.f3': 'Cross-Platform (React Native)',
  'srvPage.mobile.f4': 'App Store Optimization',
  'srvPage.mobile.f5': 'Push Notifications & Analytics',
  'srvPage.mobile.f6': 'Maintenance & Version Updates',

  'srvPage.ai.longDesc': 'The future is intelligent — and we help you get there. Our AI division builds custom machine learning models, intelligent automation systems, and data-driven tools.',
  'srvPage.ai.f1': 'Custom AI/ML Model Development',
  'srvPage.ai.f2': 'Intelligent Chatbots & Assistants',
  'srvPage.ai.f3': 'Data Analytics & Visualization',
  'srvPage.ai.f4': 'Process Automation (RPA)',
  'srvPage.ai.f5': 'Computer Vision Solutions',
  'srvPage.ai.f6': 'IoT & Smart Systems Integration',

  'srvPage.marketing.longDesc': 'Marketing without data is just guessing. We combine creativity with analytics to build campaigns that actually work — driving qualified traffic, converting leads, and scaling.',
  'srvPage.marketing.f1': 'SEO & Search Marketing',
  'srvPage.marketing.f2': 'Social Media Management',
  'srvPage.marketing.f3': 'Paid Ads (Google, Meta)',
  'srvPage.marketing.f4': 'Content Marketing Strategy',
  'srvPage.marketing.f5': 'Email Campaigns & Automation',
  'srvPage.marketing.f6': 'Revenue-Sharing Marketing Model',

  'srvPage.consulting.longDesc': 'Technology alone is not a strategy. Our consulting team audits your current state, identifies gaps, and builds a clear roadmap to digital maturity — then helps you execute it.',
  'srvPage.consulting.f1': 'Technology Audit & Assessment',
  'srvPage.consulting.f2': 'Digital Transformation Roadmap',
  'srvPage.consulting.f3': 'Cloud Migration Strategy',
  'srvPage.consulting.f4': 'Cybersecurity Consulting',
  'srvPage.consulting.f5': 'Team Training & Upskilling',
  'srvPage.consulting.f6': 'Vendor & Platform Selection',

  // SEO Meta Descriptions (150-160 chars)
  'seo.homeDesc': "Unique Code – Saudi Arabia's top digital agency. We build web apps, mobile apps & AI solutions that drive real growth. 500+ clients, 50+ countries. Start today!",
  'seo.aboutDesc': "Meet Unique Code – Riyadh's leading tech agency. 9+ years transforming businesses with web, mobile & AI. 500+ projects, 98% client satisfaction. Learn our story.",
  'seo.servicesDesc': "Web development, mobile apps, AI solutions, branding & digital marketing in Saudi Arabia. End-to-end tech services by Unique Code. Get a free consultation today!",
  'seo.contactDesc': "Contact Unique Code in Riyadh, Saudi Arabia. Reach our team for web, mobile & AI projects. We respond within 24 hours. Call, email or fill our quick contact form.",
  'seo.joinDesc': "Join Unique Code – Saudi Arabia's fastest-growing tech agency. Open roles in web dev, mobile, AI, design & marketing. Remote & hybrid. Apply now and grow with us!",
  'seo.revenueDesc': "Unique Code's revenue sharing model: zero upfront cost, we invest in your growth & earn when you do. 120+ partners, 3.8x avg growth. Book a free strategy call today.",
  'seo.privacyDesc': "Unique Code's Privacy Policy explains how we collect, use and protect your personal data. We are committed to full transparency and GDPR-aligned data protection standards.",
  'seo.termsDesc': "Read Unique Code's Terms of Service before using our digital agency services. Clear, fair terms covering IP, payments, confidentiality and dispute resolution in KSA.",
  'seo.partnershipDesc': "Apply for Unique Code's strategic partnership program. Revenue sharing model with zero upfront risk. We grow together – fill the form and hear back within 48 hours.",

  // SEO Titles
  'seo.homeTitle': 'Unique Code | Web, Mobile & AI Solutions – Saudi Arabia',
  'seo.aboutTitle': 'About Unique Code | Tech Agency – Riyadh, Saudi Arabia',
  'seo.servicesTitle': 'Web, Mobile & AI Services | Unique Code – Saudi Arabia',
  'seo.contactTitle': 'Contact Unique Code | Digital Agency – Riyadh KSA',
  'seo.joinTitle': 'Careers at Unique Code | Tech Jobs in Saudi Arabia',
  'seo.revenueTitle': 'Revenue Sharing Model | Unique Code – Grow Together',
  'seo.privacyTitle': 'Privacy Policy | Unique Code – Data Protection KSA',
  'seo.termsTitle': 'Terms of Service | Unique Code – Digital Agency KSA',
  'seo.partnershipTitle': 'Strategic Partnership Program | Unique Code – KSA',

  // Admin
  'admin.title': 'Site Dashboard',
  'admin.subtitle': 'Manage all website content',
  'admin.logout': 'Logout',
  'admin.loginTitle': 'Admin Dashboard',
  'admin.loginSubtitle': 'Enter your password to access the control panel',
  'admin.passwordLabel': 'Password',
  'admin.loginBtn': 'Login',
  'admin.loginError': 'Incorrect password. Please try again.',
  'admin.saveBtn': 'Save Changes',
  'admin.resetBtn': 'Reset Section',
  'admin.savedMsg': 'Changes saved successfully!',
  'admin.langEn': 'English',
  'admin.langAr': 'Arabic',
  'admin.searchPlaceholder': 'Search fields...',
  'admin.unsaved': 'Unsaved changes',
  'admin.confirmReset': 'Are you sure? This will reset all fields in this section to default.',
};

export default en;
